import React, { Component } from 'react';
import { actions } from './sagas/sign_up/account_information';
import { actions as company_actions } from './sagas/account';
import { selectors as company_selectors } from './sagas/account';
import { selectors as session_selectors } from './sagas/session';
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import AccountForm from './Account/form';
import './stylesheets/Account.sass';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageUpload from './shared/ImageUpload';
import config from './config';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false,
      showUploader: false
    };
    this.props.actions.company_actions.getAccountCompany()
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  uploadFinished = () => {
    this.props.actions.company_actions.getAccountCompany()
    this.setState({...this.state, showUploader: false })
  }

  toggleUploader = () => {
    this.setState({...this.state, showUploader: !this.state.showUploader })
  }

  render () {
    return (
      <div className={'account'}>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className={'account-page'}>
          <div className={'account-wrapper'}>
            <div className={'account-row'}>
              <div className={'account-title'}>
                Account
              </div>
              { this.props.initialValues && this.props.initialValues['logoUrl'] &&
                <div className={'image-center'}>
                  <img
                height={250}
                width={250}
                alt={'Account Logo'}
                src=
                  {`${config.S3_BUCKET_URL}/${this.props.initialValues['logoUrl']}`}
                />
                </div>
              }
              { this.props.loaded &&
                this.props.token &&
                (this.props.initialValues['logoUrl'] === undefined
                || this.state.showUploader) &&
                <div className={'image-upload'}>
                  <div className={'image-uploader'}>
                    <ImageUpload
                      style={{ width: 315 }}
                      token={this.props.token}
                      finished={this.uploadFinished}
                      path={'company'}
                      type={'company'}
                    />
                  </div>
                </div>
              }
              { (this.state.showUploader === false) &&
                <div className={'image-upload-wrapper'} onClick={this.toggleUploader}>
                  <button className={'image-upload-button'}>
                    Upload New Logo
                  </button>
                </div>
              }
              { this.props.initialValues && this.props.loaded &&
                <AccountForm
                initialValues={this.props.initialValues}/>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

};

const mapStateToProps = (store) => ({
  token: session_selectors.token(store),
  loaded: company_selectors.loaded(store),
  initialValues: company_selectors.account_info(store),
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      company_actions: bindActionCreators(company_actions, dispatch),
      accountActions: bindActionCreators(actions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/Account.jsx